import {Endpoints} from "../Endpoints";
import Backend from "../../Backend";

export default class Auth
{
	constructor(token)
	{
		this.backend = new Backend(token);
	}

	createUser(credentials, callback)
	{
		this.backend.callBackend(`${Endpoints.auth.private}/sign-up`, callback, "POST", credentials);
	}

	requestPhoneVerification(accessToken, callback)
	{
		this.backend.callBackend(`${Endpoints.auth.private}/get-verification-code`, callback, "POST", {
			accessToken: accessToken,
			attributeName: "phone_number"
		});
	}

	verifyPhone(accessToken, code, user, callback)
	{
		this.backend.callBackend(`${Endpoints.auth.private}/verify-account`, callback, "POST", {
			accessToken: accessToken,
			attributeName: "phone_number",
			code: code,
			username: user
		});
	}

	getPhoneNoVerificationCodeFromCognito(username, callback)
	{
		this.backend.callBackend(`${Endpoints.auth.private}/sign-in/verification-request?username=${encodeURIComponent(username)}`, callback, "POST");
	}

	verifyPhoneNoVerificationResult(otp, username, callback)
	{
		this.backend.callBackend(`${Endpoints.auth.private}/sign-in/verification-result?verificationCode=${otp}&username=${encodeURIComponent(username)}`, callback, "POST");
	}
	
	setNewPassword(session, user, newPass, callback)
	{
		this.backend.callBackend(`${Endpoints.auth.private}/sign-in/auth-challenge`, callback, "POST", {
			challengeName: "NEW_PASSWORD_REQUIRED",
			session: session,
			username: user,
			newPassword: newPass
		});
	}

	requestMFACode(user, pwd, code, callback)
	{
		this.backend.callBackend(`${Endpoints.auth.private}/log-in`, callback, "POST", {
			username: user,
			password: pwd,
			otpPath: code
		});
	}

	// validateMFACode(user, password, code, callback)
	// {
	// 	var baseURL = `${Endpoints.auth.private}/sign-in/auth-challenge/email/${code}`;

	// 	var containsHash = /#/.test(password);

	// 	if (containsHash)
	// 		password = encodeURIComponent(password);

	// 	var encodedURL = baseURL + 
	// 					"?username=" + encodeURIComponent(user) + 
	// 					"&password=" + password;
						
	// 	this.backend.callBackend(encodedURL, callback, "POST");
	// }
	
	validateMFACode(user, password, code, callback) {
		var containsHash = /#/.test(password);
		if (containsHash) {
		  password = encodeURIComponent(password);
		}
		const payload = {
		  username: user,
		  password: password,
		  otp: code
		};
		const baseURL = `${Endpoints.auth.private}/sign-in/auth-challenge/email`;
		this.backend.callBackend(baseURL, callback, "POST", payload);
	  }


	login(credentials, callback)
	{
		this.backend.callBackend(`${Endpoints.auth.private}/sign-in`, callback, "POST", credentials);
	}

	logout(callback)
	{
		this.backend.callBackend(`${Endpoints.auth.private}/sign-out`, callback);
	}

	forgotPassword(user, callback)
	{
		this.backend.callBackend(`${Endpoints.auth.private}/forgot-password`, callback, "POST", {username: user});
	}

	confirmForgotPassword(code, user, newPass, callback)
	{
		this.backend.callBackend(`${Endpoints.auth.private}/confirm-forgot-password`, callback, "POST", {
			confirmationCode: code,
			newPassword: newPass,
			username: user
		});
	}

	checkIfUserExists(username, callback)
	{
		this.backend.callBackend(`${Endpoints.auth.private}/purchaser/check-if-user-exists/${username}`, callback);
	}

	getSourceId(callback)
	{
		this.backend.callBackend(`${Endpoints.auth.private}/get-purchase-source-id`, callback);
	}

	internalUsers(callback)
	{
		this.backend.callBackend(`${Endpoints.auth.private}/get-users`, callback)
	}

	userRoles(callback)
	{
		this.backend.callBackend(`${Endpoints.auth.private}/get-roles`, callback)
	}

	addToGroup(data, callback)
	{
		this.backend.callBackend(`${Endpoints.auth.private}/add-user-to-group`, callback, 'POST', data)
	}

	removeFromGroup(data, callback)
	{
		this.backend.callBackend(`${Endpoints.auth.private}/remove-user-from-group`, callback, 'DELETE', data)
	}

	deleteUser(data, callback)
	{
		this.backend.callBackend(`${Endpoints.auth.private}/delete-user`, callback, 'DELETE', data)
	}

	toggleActive(username, callback)
	{
		this.backend.callBackend(`${Endpoints.auth.private}/disable-user`, callback, 'DELETE', {username: username})
	}
	enableTOTP(data,callback){
		this.backend.callBackend(`${Endpoints.purchaserAuth.admin}/verify-totp`, callback,"POST",data);
	}
}